// This file is autogenerated. Any changes will be overwritten.

export const set = 'streamline';

export const name = 'chain';

export const Component = () => (
  <path
    fill='none'
    stroke='currentColor'
    strokeLinecap='round'
    strokeLinejoin='round'
    d='m5.063 12.937 7.875-7.875M5.801 9.016a3.354 3.354 0 0 0-2.562.975L1.55 11.678a3.375 3.375 0 0 0 4.773 4.773l1.688-1.687a3.353 3.353 0 0 0 .975-2.563m3.213-3.219a3.354 3.354 0 0 0 2.563-.975l1.687-1.688a3.375 3.375 0 0 0-4.773-4.772L9.99 3.234a3.356 3.356 0 0 0-.972 2.563'
  />
);

export const viewBox = '0 0 18 18';
